import { jsx, jsxs } from 'react/jsx-runtime';
import { IconDesktop16MiscEmoji } from '@fabric-app/icons/svg';
import { SmallControlButton } from '@fabric-app/ui/components/Buttons/SmallControlButton';
import { DropdownMenu } from '@fabric-app/ui/components/DropdownMenu/DropdownMenu';
import { mediaHover } from '@fabric-app/ui/constants/styled-utils';
import { useResponsive } from '@fabric-app/ui/hooks/useResponsive';
import { cssVar } from '@fabric-app/ui/theme/variables';
import { useState } from 'react';
import { styled } from 'styled-components';
import { EmojiPicker } from '@fabric-app/ui/components/EmojiPicker';

const IconPicker = ({ icon, isDefault, onSave }) => {
  const [open, onOpenChange] = useState(false);
  const { isMobileView } = useResponsive();
  if (!onSave) {
    return icon ? /* @__PURE__ */ jsx(IconContainer, {
      children: icon
    }) : null;
  }
  return /* @__PURE__ */ jsx(DropdownMenu.Base, {
    openProps: {
      onOpenChange,
      open
    },
    renderTriggerElement: (props) => icon ? /* @__PURE__ */ jsx(IconContainerEditable, {
      as: DropdownMenu.Trigger,
      ...props,
      children: /* @__PURE__ */ jsx("div", {
        children: icon
      })
    }) : /* @__PURE__ */ jsxs(SmallControlButton, {
      as: DropdownMenu.Trigger,
      ...props,
      children: [
        /* @__PURE__ */ jsx(IconDesktop16MiscEmoji, {}),
        " Add icon"
      ]
    }),
    contentProps: {
      align: "start",
      style: {
        maxHeight: `min(600px, 70vh)`
      }
    },
    children: /* @__PURE__ */ jsxs(DropdownMenu.Group, {
      children: [
        !isDefault ? /* @__PURE__ */ jsx(ControlActions, {
          children: /* @__PURE__ */ jsx(SmallControlButton, {
            onClick: () => {
              onSave(null);
              onOpenChange(false);
            },
            children: "Reset to default"
          })
        }) : null,
        /* @__PURE__ */ jsx(EmojiPicker, {
          width: isMobileView ? "auto" : void 0,
          onEmojiClick: (value) => {
            if (value.isCustom) {
              onSave({
                type: "predefined",
                predefined: value.emoji
              });
            } else {
              onSave({
                type: "emoji",
                emoji: value.emoji
              });
            }
            onOpenChange(false);
          }
        })
      ]
    })
  });
};
const ControlActions = styled.div.withConfig({
  displayName: "IconPicker__ControlActions",
  componentId: "sc-90514ca2-0"
})([
  `padding:0.625rem;padding-bottom:0;display:flex;gap:0.5rem;justify-content:flex-end;`
]);
const IconContainer = styled.div.withConfig({
  displayName: "IconPicker__IconContainer",
  componentId: "sc-90514ca2-1"
})([
  `width:3rem;height:3rem;background:`,
  `;border-radius:0.25rem;font-size:2.125rem;display:flex;align-items:center;justify-content:center;padding:0.4375rem;color:`,
  `;`
], cssVar["color-bg-primary"], cssVar["color-text-tertiary"]);
const IconContainerEditable = styled(IconContainer).withConfig({
  displayName: "IconPicker__IconContainerEditable",
  componentId: "sc-90514ca2-2"
})([
  ``,
  `{&:hover *{opacity:0.7;}}`
], mediaHover);

export { IconPicker };
//# sourceMappingURL=IconPicker.js.map
